import { getNamespacedResource } from "../util";
import { ClientDate, isRecurringEvent, numberNonBusinessDaysBetween } from "Util/clientDate";
import { SIGNATORY_CHOICE_CONSTANTS } from "ESignatures/eSignatureConstants";
import { SUFFIXES } from "Forms/Components/Elements/_elementBase";
import { DATA_FIELD_TYPE, DATA_FIELD_GROUP_TYPE, DATA_FIELD_ENCODING_TYPE } from "Types/dataFieldTypes";

const PROGRAM_NAMESPACE = "program";
//getters
const DATA_FIELD_DEFINITION_FROM_ID = "dataFieldDefinitionFromId";
const DATA_FIELD_GROUP_DEFINITION_FROM_ID = "dataFieldGroupDefinitionFromId";
const DATA_FIELD_GROUP_DEFINITIONS_FROM_TYPE = "dataFieldGroupDefinitionsFromType";
const DATA_FIELD_DEFINITIONS_FROM_GROUP_ID = "dataFieldDefinitionsFromGroupId";
const LIST_ITEM_FROM_ID = "listItemFromId";
const ATTACHMENT_DEFINITION_FROM_ID = "attachmentDefinitionFromId";
const GET_ENVELOPE_DEFINITION_FROM_ID = "getEnvelopeDefinitionFromId";
const ELEMENT_DEFINITION_FROM_CLASSNAME = "elementDefinitionFromClassName";
const FORMULA_FROM_ID = "formulaFromId";
const GET_ALL_FORMULAS = "getAllFormulas";
const CALCULATED_FIELD_FROM_ID = "calculatedFieldFromId";
const GET_ALL_CALCULATED_FIELDS = "getAllCalculatedFields";
const NAMES_IN_USE = "namesInUse";
const NAMES_IN_USE_EXCLUDING = "namesInUseExcluding";
const LIST_ITEMS_BY_DATA_FIELD_ID = "getAllListItemsByDatafieldId";
const LIST_ITEM_BY_VALUE_AND_FIELD_ID = "listItemByValueAndFieldId";
const PROJECT_TABLE_SIGNALS_BY_GROUP_ID = "projectTableSignalsByGroupId";
const GET_NTH_BUSINESS_DAY = "getNthBusinessDay";
const GET_NUMBER_NON_BUSINESS_DAYS_BETWEEN = "getNumberNonBusinessDaysBetween";
const IS_BUSINESS_DAY = "isBusinessDay";
const GET_ALL_STATUSES = "getAllStatuses";
const GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_DATA_FIELD_TYPE = "getSingleInstanceDataFieldListByDataFieldType";
const GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_DATA_FIELD_TYPES = "getSingleInstanceDataFieldListByDataFieldTypes";
const GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_ENCODING_TYPE = "getSingleInstanceDataFieldListByEncodingType";
const GET_ATTACHMENT_LIST = "getAttachmentList";
const GET_FORMULA_LIST_BY_RESULT_TYPE = "getFormulaListByResultType";
const GET_SINGLE_INSTANCE_DATA_FIELD_LIST = "getSingleInstanceDataFieldList";
const GET_MULTI_INSTANCE_DATA_FIELD_LIST = "getMultiInstanceDataFieldList";
const GET_MULTI_INSTANCE_DATA_FIELD_GROUP_LIST = "getMultiInstanceDataFieldGroupList";
const GET_SHOW_PV_ENABLE_BATTERY_CONFIG = "getShowPVEnableBatteryConfig";
const ENABLE_PV_ARRAY_DESCRIPTION = "EnablePVArrayDescription";
const ENABLE_LOCATION_SUB_ELEMENT_PROPERTY = "enableLocationSubElementProperty";
const ENABLE_LOCATION_MAP_PROPERTY = "enableLocationMapProperty";
const GET_ENABLE_TABLE_IMPORT_ROWS = "getEnableTableImportRows";
const GET_ESIGNATURE_ENVELOPES_ENABLED = "getESignatureEnvelopesEnabled";
const GET_ENABLE_PROJECT_TABLE_IMPORT_ROWS = "getEnableProjectTableImportRows";
const GET_ENABLE_PROJECT_TABLE_ADD_EXISTING_PROJECT = "getEnableProjectTableAddExistingProject";
const ALL_CONTENT_LIBRARY_ITEMS = "allContentLibraryItems";
const GET_CONTENT_LIBRARY_ITEMS_BY_TYPE = "getContentLibraryItemsByType";
const GET_CONTENT_LIBRARY_ITEM_BY_ID = "getContentLibraryItemById";
const GET_ALL_ROLES = "getAllRoles";
const GET_GENERATED_DOCUMENT_TEMPLATES = "getGeneratedDocumentTemplates";
const GET_GENERATED_DOCUMENT_TEMPLATE_BY_ID = "getGeneratedDocumentTemplateById";
const GET_EXTERNAL_SERVICE_ADAPTERS = "getExternalServiceAdapters";
const GET_ADAPTER_CONFIGURATIONS = "getAdapterConfigurations";
const GET_ATTACHMENTS_CONTEXT = "getAttachmentsContext";
const GET_SIGNATORY_CONTACT_FIELDS_BY_TYPE = "getSignatoryContactFieldsByType";
const GET_ALL_INVERTER_REQUIREMENT_STANDARDS = "getAllInverterRequirementStandards";
const GET_ENABLE_ADDRESS_AUTOCOMPLETE = "getEnableAddressAutocomplete";
const GET_USE_LOCATION_FILTER = "getUseLocationFilter";
const GET_ENVELOPE_DEFINITION_LIST = "getEnvelopeDefinitionList";
const GET_TEXT_VALIDATION_RULE_BY_ID = "getTextValidationRuleById";

//mutations
const ADD_FIELD = "addField";
const DELETE_FIELD_IF_NEW = "deleteFieldIfNew";
const RENAME_FIELD = "renameField";
const RENAME_GROUP_FIELD = "renameGroupField";
const SET_FIELD_ARCHIVED = "setFieldArchived";
const COMMIT_ATTACHMENT_DATA = "commitAttachmentData";
const COMMIT_NUMERIC_SETTINGS = "commitNumericSettings";

const PROGRAM_TYPES = {
    getters: {
        [DATA_FIELD_DEFINITION_FROM_ID]: getNamespacedResource(PROGRAM_NAMESPACE, DATA_FIELD_DEFINITION_FROM_ID),
        [DATA_FIELD_GROUP_DEFINITION_FROM_ID]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            DATA_FIELD_GROUP_DEFINITION_FROM_ID
        ),
        [DATA_FIELD_GROUP_DEFINITIONS_FROM_TYPE]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            DATA_FIELD_GROUP_DEFINITIONS_FROM_TYPE
        ),
        [DATA_FIELD_DEFINITIONS_FROM_GROUP_ID]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            DATA_FIELD_DEFINITIONS_FROM_GROUP_ID
        ),
        [LIST_ITEM_FROM_ID]: getNamespacedResource(PROGRAM_NAMESPACE, LIST_ITEM_FROM_ID),
        [LIST_ITEM_BY_VALUE_AND_FIELD_ID]: getNamespacedResource(PROGRAM_NAMESPACE, LIST_ITEM_BY_VALUE_AND_FIELD_ID),
        [PROJECT_TABLE_SIGNALS_BY_GROUP_ID]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            PROJECT_TABLE_SIGNALS_BY_GROUP_ID
        ),
        [ATTACHMENT_DEFINITION_FROM_ID]: getNamespacedResource(PROGRAM_NAMESPACE, ATTACHMENT_DEFINITION_FROM_ID),
        [GET_ENVELOPE_DEFINITION_FROM_ID]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ENVELOPE_DEFINITION_FROM_ID),
        [ELEMENT_DEFINITION_FROM_CLASSNAME]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            ELEMENT_DEFINITION_FROM_CLASSNAME
        ),
        [FORMULA_FROM_ID]: getNamespacedResource(PROGRAM_NAMESPACE, FORMULA_FROM_ID),
        [GET_ALL_FORMULAS]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ALL_FORMULAS),
        [CALCULATED_FIELD_FROM_ID]: getNamespacedResource(PROGRAM_NAMESPACE, CALCULATED_FIELD_FROM_ID),
        [GET_ALL_CALCULATED_FIELDS]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ALL_CALCULATED_FIELDS),
        [NAMES_IN_USE]: getNamespacedResource(PROGRAM_NAMESPACE, NAMES_IN_USE),
        [NAMES_IN_USE_EXCLUDING]: getNamespacedResource(PROGRAM_NAMESPACE, NAMES_IN_USE_EXCLUDING),
        [LIST_ITEMS_BY_DATA_FIELD_ID]: getNamespacedResource(PROGRAM_NAMESPACE, LIST_ITEMS_BY_DATA_FIELD_ID),
        [GET_NTH_BUSINESS_DAY]: getNamespacedResource(PROGRAM_NAMESPACE, GET_NTH_BUSINESS_DAY),
        [GET_NUMBER_NON_BUSINESS_DAYS_BETWEEN]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_NUMBER_NON_BUSINESS_DAYS_BETWEEN
        ),
        [IS_BUSINESS_DAY]: getNamespacedResource(PROGRAM_NAMESPACE, IS_BUSINESS_DAY),
        [GET_ALL_STATUSES]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ALL_STATUSES),
        [GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_DATA_FIELD_TYPE]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_DATA_FIELD_TYPE
        ),
        [GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_DATA_FIELD_TYPES]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_DATA_FIELD_TYPES
        ),
        [GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_ENCODING_TYPE]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_ENCODING_TYPE
        ),
        [GET_ATTACHMENT_LIST]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ATTACHMENT_LIST),
        [GET_ENVELOPE_DEFINITION_LIST]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ENVELOPE_DEFINITION_LIST),
        [GET_FORMULA_LIST_BY_RESULT_TYPE]: getNamespacedResource(PROGRAM_NAMESPACE, GET_FORMULA_LIST_BY_RESULT_TYPE),
        [GET_SINGLE_INSTANCE_DATA_FIELD_LIST]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_SINGLE_INSTANCE_DATA_FIELD_LIST
        ),
        [GET_MULTI_INSTANCE_DATA_FIELD_LIST]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_MULTI_INSTANCE_DATA_FIELD_LIST
        ),
        [GET_MULTI_INSTANCE_DATA_FIELD_GROUP_LIST]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_MULTI_INSTANCE_DATA_FIELD_GROUP_LIST
        ),
        [GET_SHOW_PV_ENABLE_BATTERY_CONFIG]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_SHOW_PV_ENABLE_BATTERY_CONFIG
        ),
        [ENABLE_PV_ARRAY_DESCRIPTION]: getNamespacedResource(PROGRAM_NAMESPACE, ENABLE_PV_ARRAY_DESCRIPTION),
        [ENABLE_LOCATION_SUB_ELEMENT_PROPERTY]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            ENABLE_LOCATION_SUB_ELEMENT_PROPERTY
        ),
        [ENABLE_LOCATION_MAP_PROPERTY]: getNamespacedResource(PROGRAM_NAMESPACE, ENABLE_LOCATION_MAP_PROPERTY),
        [GET_ENABLE_TABLE_IMPORT_ROWS]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ENABLE_TABLE_IMPORT_ROWS),
        [GET_ESIGNATURE_ENVELOPES_ENABLED]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ESIGNATURE_ENVELOPES_ENABLED),
        [GET_ENABLE_PROJECT_TABLE_IMPORT_ROWS]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_ENABLE_PROJECT_TABLE_IMPORT_ROWS
        ),
        [GET_ENABLE_PROJECT_TABLE_ADD_EXISTING_PROJECT]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_ENABLE_PROJECT_TABLE_ADD_EXISTING_PROJECT
        ),
        [ALL_CONTENT_LIBRARY_ITEMS]: getNamespacedResource(PROGRAM_NAMESPACE, ALL_CONTENT_LIBRARY_ITEMS),
        [GET_CONTENT_LIBRARY_ITEMS_BY_TYPE]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_CONTENT_LIBRARY_ITEMS_BY_TYPE
        ),
        [GET_CONTENT_LIBRARY_ITEM_BY_ID]: getNamespacedResource(PROGRAM_NAMESPACE, GET_CONTENT_LIBRARY_ITEM_BY_ID),
        [GET_ALL_ROLES]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ALL_ROLES),
        [GET_GENERATED_DOCUMENT_TEMPLATES]: getNamespacedResource(PROGRAM_NAMESPACE, GET_GENERATED_DOCUMENT_TEMPLATES),
        [GET_GENERATED_DOCUMENT_TEMPLATE_BY_ID]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_GENERATED_DOCUMENT_TEMPLATE_BY_ID
        ),
        [GET_EXTERNAL_SERVICE_ADAPTERS]: getNamespacedResource(PROGRAM_NAMESPACE, GET_EXTERNAL_SERVICE_ADAPTERS),
        [GET_ADAPTER_CONFIGURATIONS]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ADAPTER_CONFIGURATIONS),
        [GET_ATTACHMENTS_CONTEXT]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ATTACHMENTS_CONTEXT),
        [GET_SIGNATORY_CONTACT_FIELDS_BY_TYPE]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_SIGNATORY_CONTACT_FIELDS_BY_TYPE
        ),
        [GET_ALL_INVERTER_REQUIREMENT_STANDARDS]: getNamespacedResource(
            PROGRAM_NAMESPACE,
            GET_ALL_INVERTER_REQUIREMENT_STANDARDS
        ),
        [GET_ENABLE_ADDRESS_AUTOCOMPLETE]: getNamespacedResource(PROGRAM_NAMESPACE, GET_ENABLE_ADDRESS_AUTOCOMPLETE),
        [GET_USE_LOCATION_FILTER]: getNamespacedResource(PROGRAM_NAMESPACE, GET_USE_LOCATION_FILTER),
        [GET_TEXT_VALIDATION_RULE_BY_ID]: getNamespacedResource(PROGRAM_NAMESPACE, GET_TEXT_VALIDATION_RULE_BY_ID)
    },
    mutations: {
        [ADD_FIELD]: getNamespacedResource(PROGRAM_NAMESPACE, ADD_FIELD),
        [DELETE_FIELD_IF_NEW]: getNamespacedResource(PROGRAM_NAMESPACE, DELETE_FIELD_IF_NEW),
        [RENAME_FIELD]: getNamespacedResource(PROGRAM_NAMESPACE, RENAME_FIELD),
        [RENAME_GROUP_FIELD]: getNamespacedResource(PROGRAM_NAMESPACE, RENAME_GROUP_FIELD),
        [SET_FIELD_ARCHIVED]: getNamespacedResource(PROGRAM_NAMESPACE, SET_FIELD_ARCHIVED),
        [COMMIT_ATTACHMENT_DATA]: getNamespacedResource(PROGRAM_NAMESPACE, COMMIT_ATTACHMENT_DATA),
        [COMMIT_NUMERIC_SETTINGS]: getNamespacedResource(PROGRAM_NAMESPACE, COMMIT_NUMERIC_SETTINGS)
    }
};

export { PROGRAM_NAMESPACE, PROGRAM_TYPES };

function translateCustomIdToPublicIfNecessary(customToPublicMap, id) {
    if (customToPublicMap.hasOwnProperty(id)) {
        return customToPublicMap[id];
    }
    return id;
}

export function createProgramModule($app, state) {
    return {
        namespaced: true,
        state: state,
        getters: {
            customIdToDataFieldDefinitionPublicIdMap(state) {
                const map = {};
                for (const [key, value] of Object.entries(state.Definitions.DataFieldDefinitions)) {
                    if (value.CustomId) {
                        map[value.CustomId] = key;
                    }
                }
                return map;
            },
            [DATA_FIELD_DEFINITION_FROM_ID](state, getters) {
                return function (dataFieldId) {
                    dataFieldId = translateCustomIdToPublicIfNecessary(
                        getters.customIdToDataFieldDefinitionPublicIdMap,
                        dataFieldId
                    );
                    return state.Definitions.DataFieldDefinitions[dataFieldId];
                };
            },
            [DATA_FIELD_GROUP_DEFINITION_FROM_ID](state) {
                return function (dataFieldGroupId) {
                    return state.Definitions.DataFieldGroupDefinitions[dataFieldGroupId];
                };
            },
            [DATA_FIELD_GROUP_DEFINITIONS_FROM_TYPE](state) {
                return function (typeId) {
                    return Object.values(state.Definitions.DataFieldGroupDefinitions)
                        .filter((dfgd) => dfgd.TypeId === typeId)
                        .sort((a, b) => comparison(a, b, "Name"));
                };
            },
            [DATA_FIELD_DEFINITIONS_FROM_GROUP_ID](state, getters) {
                return function (dataFieldGroupId) {
                    const group = getters[DATA_FIELD_GROUP_DEFINITION_FROM_ID](dataFieldGroupId);
                    return group.DataFieldIds.map((dfdId) => getters[DATA_FIELD_DEFINITION_FROM_ID](dfdId));
                };
            },
            [LIST_ITEM_FROM_ID](state) {
                return function (listItemId) {
                    return state.Definitions.ListItems[listItemId];
                };
            },
            [LIST_ITEM_BY_VALUE_AND_FIELD_ID](state, getters) {
                return function (listItemValue, dataFieldId) {
                    const listItems = getters[LIST_ITEMS_BY_DATA_FIELD_ID](dataFieldId);
                    const foundItem = listItems.find((li) => !li.IsDeleted && li.Value === listItemValue);
                    return foundItem;
                };
            },
            [PROJECT_TABLE_SIGNALS_BY_GROUP_ID]: (state) => (groupId) => {
                return state.Definitions.ProjectTableSignals[groupId] ?? [];
            },
            [ATTACHMENT_DEFINITION_FROM_ID](state) {
                return function (attachmentId) {
                    return state.Definitions.AttachmentDefinitions[attachmentId];
                };
            },
            [GET_ENVELOPE_DEFINITION_FROM_ID](state) {
                return function (envelopeId) {
                    return state.EnvelopeDefinitions[envelopeId];
                };
            },
            [ELEMENT_DEFINITION_FROM_CLASSNAME](state) {
                return function (className) {
                    return state.Definitions.ElementDefinitions[className];
                };
            },
            [FORMULA_FROM_ID](state) {
                return function (formulaId) {
                    return state.Formulas[formulaId];
                };
            },
            [GET_ALL_FORMULAS](state) {
                return state.Formulas;
            },
            [CALCULATED_FIELD_FROM_ID](state) {
                return function (calculatedFieldId) {
                    return state.CalculatedFields[calculatedFieldId];
                };
            },
            [GET_ALL_CALCULATED_FIELDS](state) {
                return state.CalculatedFields;
            },
            [NAMES_IN_USE](state) {
                if (!state.Definitions) {
                    return null;
                }
                const namesInUse = {};
                let publicId;
                for (publicId in state.Definitions.DataFieldDefinitions) {
                    if (state.Definitions.DataFieldDefinitions.hasOwnProperty(publicId)) {
                        namesInUse[state.Definitions.DataFieldDefinitions[publicId].Name] = true;
                    }
                }
                for (publicId in state.Definitions.DataFieldGroupDefinitions) {
                    if (state.Definitions.DataFieldGroupDefinitions.hasOwnProperty(publicId)) {
                        namesInUse[state.Definitions.DataFieldGroupDefinitions[publicId].Name] = true;
                    }
                }
                for (publicId in state.Definitions.AttachmentDefinitions) {
                    if (state.Definitions.AttachmentDefinitions.hasOwnProperty(publicId)) {
                        namesInUse[state.Definitions.AttachmentDefinitions[publicId].Name] = true;
                    }
                }
                return namesInUse;
            },
            [NAMES_IN_USE_EXCLUDING](state) {
                return function (dataFieldIds, dataFieldGroupIds, attachmentIds) {
                    const dataFieldMap = {};
                    dataFieldIds.forEach((dfid) => (dataFieldMap[dfid] = true));
                    const dataFieldGroupMap = {};
                    dataFieldGroupIds.forEach((dfgid) => (dataFieldGroupMap[dfgid] = true));
                    const attachmentsMap = {};
                    attachmentIds.forEach((aid) => (attachmentsMap[aid] = true));

                    const namesInUse = {};
                    let publicId;
                    for (publicId in state.Definitions.DataFieldDefinitions) {
                        const dataFieldGroupId =
                            state.Definitions.DataFieldDefinitions[publicId].DataFieldGroupId ?? "";
                        if (
                            !dataFieldMap.hasOwnProperty(publicId) &&
                            !dataFieldGroupMap.hasOwnProperty(dataFieldGroupId)
                        ) {
                            namesInUse[state.Definitions.DataFieldDefinitions[publicId].Name] = true;
                        }
                    }
                    for (publicId in state.Definitions.DataFieldGroupDefinitions) {
                        if (!dataFieldGroupMap.hasOwnProperty(publicId)) {
                            namesInUse[state.Definitions.DataFieldGroupDefinitions[publicId].Name] = true;
                        }
                    }
                    for (publicId in state.Definitions.AttachmentDefinitions) {
                        if (!attachmentsMap.hasOwnProperty(publicId)) {
                            namesInUse[state.Definitions.AttachmentDefinitions[publicId].Name] = true;
                        }
                    }
                    return namesInUse;
                };
            },
            [LIST_ITEMS_BY_DATA_FIELD_ID](state) {
                return function (dataFieldId) {
                    const dataField = state.Definitions.DataFieldDefinitions[dataFieldId];
                    const listItems = [];
                    if (dataField && dataField.ListId) {
                        const listItemIds = state.Definitions.Lists[dataField.ListId].ListItemIds;
                        for (let i = 0; i < listItemIds.length; i++) {
                            listItems.push(state.Definitions.ListItems[listItemIds[i]]);
                        }
                    }
                    return listItems;
                };
            },
            [GET_NTH_BUSINESS_DAY](state, getters) {
                return function (clientDate, nDays) {
                    const dayStep = nDays < 0 ? -1 : 1;
                    let nthDate = new ClientDate($app, clientDate.Year, clientDate.Month, clientDate.Day);

                    // Start counting from the next closest business day if start is not business day
                    while (!getters[IS_BUSINESS_DAY](nthDate)) {
                        nthDate = nthDate.addDays(dayStep);
                    }

                    while (nDays !== 0) {
                        nthDate = nthDate.addDays(dayStep);
                        if (getters[IS_BUSINESS_DAY](nthDate)) {
                            nDays -= dayStep;
                        }
                    }
                    return nthDate;
                };
            },
            [GET_NUMBER_NON_BUSINESS_DAYS_BETWEEN](state) {
                return function (startDate, endDate) {
                    return numberNonBusinessDaysBetween($app, startDate, endDate, state.BusinessCalendar);
                };
            },
            [IS_BUSINESS_DAY](state) {
                return function (clientDate) {
                    if (!(clientDate instanceof ClientDate)) {
                        clientDate = new ClientDate($app, clientDate.Year, clientDate.Month, clientDate.Day);
                    }

                    const dayOfWeek = clientDate.getDayOfWeek();
                    if (!state.BusinessCalendar.BusinessWeek[dayOfWeek]) {
                        return false;
                    }

                    if (state.BusinessCalendar.TimeOff) {
                        const matchingTimeOffs = state.BusinessCalendar.TimeOff.filter(function (to) {
                            return clientDate.equals(to);
                        });
                        if (matchingTimeOffs.length > 0) {
                            return false;
                        }
                    }

                    if (state.BusinessCalendar.RecurringRules) {
                        for (let i = 0; i < state.BusinessCalendar.RecurringRules.length; i++) {
                            if (isRecurringEvent(state.BusinessCalendar.RecurringRules[i], clientDate)) {
                                return false;
                            }
                        }
                    }

                    return true;
                };
            },
            [GET_ALL_STATUSES](state) {
                return state.WorkflowStatuses;
            },
            [GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_DATA_FIELD_TYPE](state) {
                return function (dataFieldType) {
                    return Object.values(state.Definitions.DataFieldDefinitions)
                        .filter((x) => x.TypeId === dataFieldType && !x.IsMultiInstance)
                        .sort((a, b) => comparison(a, b, "Name"));
                };
            },
            [GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_DATA_FIELD_TYPES](state) {
                return function (dataFieldTypes) {
                    const typeMap = {};
                    dataFieldTypes.forEach((type) => (typeMap[type] = true));
                    return Object.values(state.Definitions.DataFieldDefinitions)
                        .filter((x) => typeMap.hasOwnProperty(x.TypeId) && !x.IsMultiInstance)
                        .sort((a, b) => comparison(a, b, "Name"));
                };
            },
            [GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_ENCODING_TYPE](state) {
                return function (encodingType) {
                    return Object.values(state.Definitions.DataFieldDefinitions)
                        .filter((x) => x.EncodingTypeId === encodingType && !x.IsMultiInstance)
                        .sort((a, b) => comparison(a, b, "Name"));
                };
            },
            [GET_ATTACHMENT_LIST](state) {
                return function () {
                    return Object.values(state.Definitions.AttachmentDefinitions).sort((a, b) =>
                        comparison(a, b, "Name")
                    );
                };
            },
            [GET_ENVELOPE_DEFINITION_LIST](state) {
                return function () {
                    return Object.values(state.EnvelopeDefinitions).sort((a, b) => comparison(a, b, "Name"));
                };
            },
            [GET_FORMULA_LIST_BY_RESULT_TYPE](state) {
                return function (resultType) {
                    return Object.values(state.Formulas)
                        .filter((x) => x.ResultType === resultType)
                        .sort((a, b) => comparison(a, b, "DisplayName"));
                };
            },
            [GET_SINGLE_INSTANCE_DATA_FIELD_LIST](state) {
                return function () {
                    return Object.values(state.Definitions.DataFieldDefinitions)
                        .filter((x) => !x.IsMultiInstance)
                        .sort((a, b) => comparison(a, b, "Name"));
                };
            },
            [GET_MULTI_INSTANCE_DATA_FIELD_LIST](state) {
                return function () {
                    return Object.values(state.Definitions.DataFieldDefinitions)
                        .filter((x) => x.IsMultiInstance)
                        .sort((a, b) => comparison(a, b, "Name"));
                };
            },
            [GET_MULTI_INSTANCE_DATA_FIELD_GROUP_LIST](state) {
                return function () {
                    return Object.values(state.Definitions.DataFieldGroupDefinitions).sort((a, b) =>
                        comparison(a, b, "Name")
                    );
                };
            },
            [ALL_CONTENT_LIBRARY_ITEMS](state) {
                return Object.values(state.ContentLibraryItems).sort((a, b) => comparison(a, b, "Name"));
            },
            [GET_CONTENT_LIBRARY_ITEMS_BY_TYPE](state, getters) {
                return function (contentLibraryItemType) {
                    return getters[ALL_CONTENT_LIBRARY_ITEMS].filter((cli) => cli.FileType === contentLibraryItemType);
                };
            },
            [GET_CONTENT_LIBRARY_ITEM_BY_ID](state) {
                return function (contentLibraryItemId) {
                    return state.ContentLibraryItems[contentLibraryItemId];
                };
            },
            [GET_SHOW_PV_ENABLE_BATTERY_CONFIG](state) {
                return state.ShowPVEnableBatteryConfig;
            },
            [ENABLE_PV_ARRAY_DESCRIPTION](state) {
                return state.EnablePVArrayDescription;
            },
            [ENABLE_LOCATION_SUB_ELEMENT_PROPERTY](state) {
                return state.EnableLocationSubElement;
            },
            [ENABLE_LOCATION_MAP_PROPERTY](state) {
                return state.EnableLocationMap;
            },
            [GET_ENABLE_TABLE_IMPORT_ROWS](state) {
                return state.EnableTableImportRows;
            },
            [GET_ESIGNATURE_ENVELOPES_ENABLED](state) {
                return state.ESignatureEnvelopesEnabled;
            },
            [GET_ENABLE_PROJECT_TABLE_IMPORT_ROWS](state) {
                return state.EnableProjectTableImportRows;
            },
            [GET_ENABLE_PROJECT_TABLE_ADD_EXISTING_PROJECT](state) {
                return state.EnableProjectTableAddExistingProject;
            },
            [GET_ALL_ROLES](state) {
                return state.Roles;
            },
            [GET_GENERATED_DOCUMENT_TEMPLATES](state) {
                return state.GeneratedDocumentTemplates;
            },
            [GET_GENERATED_DOCUMENT_TEMPLATE_BY_ID](state) {
                return function (documentTemplateId) {
                    return state.GeneratedDocumentTemplates[documentTemplateId];
                };
            },
            [GET_EXTERNAL_SERVICE_ADAPTERS](state) {
                return state.ExternalServiceAdapters;
            },
            [GET_ADAPTER_CONFIGURATIONS](state) {
                return state.AdapterConfigurations;
            },
            [GET_ATTACHMENTS_CONTEXT](state) {
                return state.AttachmentsContext;
            },
            [GET_SIGNATORY_CONTACT_FIELDS_BY_TYPE](state, getters) {
                const names = getters[DATA_FIELD_GROUP_DEFINITIONS_FROM_TYPE](DATA_FIELD_GROUP_TYPE.Name);
                const contacts = getters[DATA_FIELD_GROUP_DEFINITIONS_FROM_TYPE](DATA_FIELD_GROUP_TYPE.Contact);
                const validNameContactGroups = names.concat(contacts);

                function fieldToSelectorOption(dfd) {
                    return { text: dfd.Name, value: dfd.PublicId };
                }

                // all four data fields lists generated in the same set of loops for performance
                const signatoryChoiceOptionsData = {
                    [SIGNATORY_CHOICE_CONSTANTS.FirstNameDataFields]: [],
                    [SIGNATORY_CHOICE_CONSTANTS.LastNameDataFields]: [],
                    [SIGNATORY_CHOICE_CONSTANTS.EmailDataFields]: [],
                    [SIGNATORY_CHOICE_CONSTANTS.UserDataFields]: []
                };

                // Track IDs of email fields we include from contact groups so we don't
                // get duplicates when we include all email-encoded fields
                const emailDeduplicationMap = {};
                validNameContactGroups.forEach((dfg) => {
                    const groupFields = getters[DATA_FIELD_DEFINITIONS_FROM_GROUP_ID](dfg.PublicId);
                    for (const dfd of groupFields) {
                        if (dfd.IsArchived || dfd.IsDraft) {
                            continue;
                        }

                        if (dfd.Name.endsWith(SUFFIXES.Name.First)) {
                            signatoryChoiceOptionsData[SIGNATORY_CHOICE_CONSTANTS.FirstNameDataFields].push(
                                fieldToSelectorOption(dfd)
                            );
                        } else if (dfd.Name.endsWith(SUFFIXES.Name.Last)) {
                            signatoryChoiceOptionsData[SIGNATORY_CHOICE_CONSTANTS.LastNameDataFields].push(
                                fieldToSelectorOption(dfd)
                            );
                        } else if (dfd.Name.endsWith(SUFFIXES.Contact.Email) && !dfd.IsMultiInstance) {
                            signatoryChoiceOptionsData[SIGNATORY_CHOICE_CONSTANTS.EmailDataFields].push(
                                fieldToSelectorOption(dfd)
                            );
                            emailDeduplicationMap[dfd.PublicId] = true;
                        }
                    }
                });

                // Add standalone, single-instance Email fields, but avoid duplicates
                const emailEncodedFields = getters[GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_ENCODING_TYPE](
                    DATA_FIELD_ENCODING_TYPE.Email
                )
                    .map((dfd) => fieldToSelectorOption(dfd))
                    .filter((eef) => !emailDeduplicationMap.hasOwnProperty(eef.value) && !eef.IsDraft);

                // Add these email fields to our existing list of email fields from groups
                signatoryChoiceOptionsData[SIGNATORY_CHOICE_CONSTANTS.EmailDataFields] =
                    signatoryChoiceOptionsData[SIGNATORY_CHOICE_CONSTANTS.EmailDataFields].concat(emailEncodedFields);

                // Add User data fields
                signatoryChoiceOptionsData[SIGNATORY_CHOICE_CONSTANTS.UserDataFields] = getters[
                    GET_SINGLE_INSTANCE_DATA_FIELD_LIST_BY_DATA_FIELD_TYPE
                ](DATA_FIELD_TYPE.User)
                    .map((dfd) => fieldToSelectorOption(dfd))
                    .filter((dfd) => !dfd.IsDraft);

                // Sort all option lists by name
                for (const optionType in signatoryChoiceOptionsData) {
                    if (signatoryChoiceOptionsData.hasOwnProperty(optionType)) {
                        const options = signatoryChoiceOptionsData[optionType];
                        // Sort modifies the array in place
                        options.sort((a, b) => a.text.localeCompare(b.text));
                    }
                }

                return signatoryChoiceOptionsData;
            },
            [GET_ALL_INVERTER_REQUIREMENT_STANDARDS](state) {
                return state.InverterRequirementStandards;
            },
            [GET_ENABLE_ADDRESS_AUTOCOMPLETE](state) {
                return state.EnableAddressAutocomplete;
            },
            [GET_USE_LOCATION_FILTER](state) {
                return state.LocationFilter !== null;
            },
            [GET_TEXT_VALIDATION_RULE_BY_ID](state) {
                return function (textValidationRuleId) {
                    return state.Definitions.TextValidationRules[textValidationRuleId];
                };
            }
        },
        mutations: {
            [ADD_FIELD](state, { dataField, dataFieldGroup, attachment, formula, calculatedField }) {
                if (dataField) {
                    state.Definitions.DataFieldDefinitions[dataField.PublicId] = dataField;
                } else if (dataFieldGroup) {
                    state.Definitions.DataFieldGroupDefinitions[dataFieldGroup.PublicId] = dataFieldGroup;
                } else if (attachment) {
                    state.Definitions.AttachmentDefinitions[attachment.PublicId] = attachment;
                } else if (formula) {
                    state.Formulas[formula.PublicId] = formula;
                } else if (calculatedField) {
                    state.CalculatedFields[calculatedField.PublicId] = calculatedField;
                }
            },
            [DELETE_FIELD_IF_NEW](state, { dataFieldId, dataFieldGroupId, attachmentId, formulaId }) {
                if (dataFieldId) {
                    const field = state.Definitions.DataFieldDefinitions[dataFieldId];
                    if (field && field.IsNew) {
                        delete state.Definitions.DataFieldDefinitions[dataFieldId];
                    }
                } else if (dataFieldGroupId) {
                    const group = state.Definitions.DataFieldGroupDefinitions[dataFieldGroupId];
                    if (group && group.IsNew) {
                        delete state.Definitions.DataFieldGroupDefinitions[dataFieldGroupId];
                    }
                } else if (attachmentId) {
                    const attachment = state.Definitions.AttachmentDefinitions[attachmentId];
                    if (attachment && attachment.IsNew) {
                        delete state.Definitions.AttachmentDefinitions[attachmentId];
                    }
                } else if (formulaId) {
                    const formula = state.Formulas[formulaId];
                    if (formula) {
                        delete state.Formulas[formulaId];
                    }
                }
            },
            [RENAME_FIELD](state, { dataFieldId, dataFieldGroupId, attachmentId, calculatedFieldId, newName }) {
                let entity;
                if (dataFieldId) {
                    entity = state.Definitions.DataFieldDefinitions[dataFieldId];
                } else if (dataFieldGroupId) {
                    entity = state.Definitions.DataFieldGroupDefinitions[dataFieldGroupId];
                } else if (attachmentId) {
                    entity = state.Definitions.AttachmentDefinitions[attachmentId];
                } else if (calculatedFieldId) {
                    entity = state.CalculatedFields[calculatedFieldId];
                }
                if (entity) {
                    if (entity.hasOwnProperty("Name")) {
                        entity.Name = newName;
                    } else if (entity.hasOwnProperty("DisplayName")) {
                        entity.DisplayName = newName;
                    }
                }
            },
            [RENAME_GROUP_FIELD](state, { dataFieldGroupId, className, groupName }) {
                const group = state.Definitions.DataFieldGroupDefinitions[dataFieldGroupId];
                const groupSchema = state.Definitions.ElementDefinitions[className].Schema.GroupSchema;
                if (group) {
                    for (let index = 0; index < group.DataFieldIds.length; index++) {
                        const suffix = groupSchema.ChildFields[index].Suffix;
                        const dataField = state.Definitions.DataFieldDefinitions[group.DataFieldIds[index]];
                        dataField.Name = groupName + suffix;
                    }
                }
            },
            [SET_FIELD_ARCHIVED](
                state,
                { dataFieldId, dataFieldGroupId, attachmentId, calculatedFieldId, archived, newName }
            ) {
                let entity;
                if (dataFieldId) {
                    entity = state.Definitions.DataFieldDefinitions[dataFieldId];
                } else if (dataFieldGroupId) {
                    entity = state.Definitions.DataFieldGroupDefinitions[dataFieldGroupId];
                } else if (attachmentId) {
                    entity = state.Definitions.AttachmentDefinitions[attachmentId];
                } else if (calculatedFieldId) {
                    entity = state.CalculatedFields[calculatedFieldId];
                }
                if (entity) {
                    entity.IsArchived = archived;
                    if (entity.Name) {
                        entity.Name = newName;
                    } else if (entity.DisplayName) {
                        entity.DisplayName = newName;
                    }
                }
            },
            [COMMIT_ATTACHMENT_DATA](state, { attachmentId, attachmentData }) {
                const attachmentDefinition = state.Definitions.AttachmentDefinitions[attachmentId];
                if (attachmentDefinition) {
                    attachmentDefinition.AllowedExtensions = attachmentData.AllowedExtensions;
                    attachmentDefinition.AllowsLarge = attachmentData.AllowsLarge;
                    attachmentDefinition.CanMerge = attachmentData.CanMerge;
                    attachmentDefinition.IsSensitive = attachmentData.IsSensitive;
                }
            },
            [COMMIT_NUMERIC_SETTINGS](state, { dataFieldId, numericData }) {
                const dataFieldDefinition = state.Definitions.DataFieldDefinitions[dataFieldId];
                if (dataFieldDefinition) {
                    dataFieldDefinition.ShowSeparators = numericData.showThousandSeparators;
                }
            }
        }
    };
}

function comparison(a, b, propertyName) {
    const alower = a[propertyName].toLowerCase();
    const blower = b[propertyName].toLowerCase();
    return alower > blower ? 1 : alower < blower ? -1 : 0;
}
